
import server from '../../public/server/server'
const mediaApi = {
    //----------------------应急广播-----------------------------------
    queryListByPage:server.requestPath +  '/broadcast/queryListByPage', // 获取列表
    save:server.requestPath +  '/broadcast/save', // 发布广播
    del:server.requestPath +  '/broadcast/del', // 删除广播
	// ---------------------系统公告----------------------------------
    queryListByPageMsg:server.requestPath +  '/message/queryListByPage', // 获取公告列表
    saveMsg:server.requestPath +  '/message/save', // 发布公告
    delMsg:server.requestPath +  '/message/del', // 删除公告
	// 群防群治
    groupConSave:server.requestPath +  '/groupCon/save', // 
    groupConEnabled:server.requestPath +  '/groupCon/enabled', // 
    groupConDetail:server.requestPath +  '/groupCon/detail', // 
    groupConDel:server.requestPath +  '/groupCon/del', // 
    groupConList:server.requestPath +  '/groupCon/List', // 
}


export {
	mediaApi
}
